import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useUserDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      console.log('Deleting product with ID:', id);
      const res = await api.delete(`/user/delete/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['usersList'],
      });
      queryClient.invalidateQueries({
        queryKey: ['viewSubscription'],
      });
    },
  });
};